module.exports = __webpack_public_path__ + "assets/1df456c8fed8938d6382e05583f20488.mp3";